<div class="page has-breadcrumb">
  <h1
    *ngIf="breakpointMdMin"
    class="d-flex justify-content-between align-items-center align-items-lg-end flex-column flex-lg-row gap-1"
  >
    <span class="d-block flex-grow-1 me-lg-3 mb-1 mb-lg-0">
      <span class="d-block mb-0 mb-lg-2">
        {{ title }}
      </span>

      <ng-container *ngIf="deviceService.mdMin()" [ngTemplateOutlet]="descriptionTemplate"> </ng-container>

      <a [routerLink]="['/', 'equipment', 'marketplace']" class="d-block d-lg-none mt-3 mb-3 back-to-marketplace">
        <fa-icon icon="arrow-left"></fa-icon>
        {{ "Back to marketplace" | translate }}
      </a>
    </span>
  </h1>

  <ng-container *ngIf="currentUserWrapper$ | async as currentUserWrapper">
    <ng-container *ngIf="listingContentType$ | async as listingContentType; else loadingTemplate">
      <ng-container *ngIf="listingUser$ | async as listingUser; else loadingTemplate">
        <div class="row">
          <div class="col-md-8 col-lg-9 order-2 order-md-1">
            <div *ngIf="!listing.approved" class="alert alert-warning" role="alert">
              <fa-icon icon="exclamation-triangle"></fa-icon>
              {{ "This listing is pending moderation." | translate }}

              <span
                *ngIf="currentUser$ | async | isMarketplaceModerator"
                class="mt-2 mt-md-0 ms-md-2 d-block d-md-inline-block float-md-end"
              >
                <button
                  [class.loading]="loadingService.loading$ | async"
                  (click)="approve()"
                  class="btn btn-link btn-no-block"
                >
                  <fa-icon icon="check"></fa-icon>
                </button>

                <a
                  *ngIf="!equipmentMarketplaceService.listingSold(listing)"
                  [class.loading]="loadingService.loading$ | async"
                  [routerLink]="'edit'"
                  class="btn btn-link btn-no-block ms-md-2"
                >
                  <fa-icon icon="pencil"></fa-icon>
                </a>

                <button
                  *ngIf="!equipmentMarketplaceService.listingSold(listing)"
                  [class.loading]="loadingService.loading$ | async"
                  (click)="delete()"
                  class="btn btn-link btn-no-block ms-md-2"
                >
                  <fa-icon icon="trash-alt"></fa-icon>
                </button>
              </span>
            </div>

            <astrobin-marketplace-listing [listing]="listing"></astrobin-marketplace-listing>

            <astrobin-nested-comments
              [addCommentLabel]="'Ask a question' | translate"
              [allowSelfReply]="false"
              [contentType]="listingContentType"
              [info]="
                currentUserWrapper.user?.id !== listing.user
                  ? ('Questions asked here are publicly visible. If you want to contact the user in a private ' +
                      'conversation, use the \'Message user privately\' button.' | translate)
                  : null
              "
              [noCommentsLabel]="'There are no questions or discussions yet.'"
              [objectId]="listing.id"
              [restrictReplyToUserId]="currentUserWrapper.user?.id !== listing.user ? listing.user : null"
              [showTopLevelButton]="currentUserWrapper.user?.id !== listing.user"
              [title]="'Public questions' | translate"
            ></astrobin-nested-comments>

            <astrobin-marketplace-more-from-user
              [listing]="listing"
              class="d-block mt-5"
            ></astrobin-marketplace-more-from-user>
          </div>

          <div class="col-md-4 col-lg-3 order-1 order-md-2 mb-4 mb-lg-0 mt-2 mt-lg-0">
            <astrobin-marketplace-user-card [listing]="listing" class="d-block"></astrobin-marketplace-user-card>

            <div *ngIf="currentUserWrapper.user | isMarketplaceModerator" class="alert alert-warning mt-4">
              <fa-icon icon="exclamation-triangle"></fa-icon>
              {{ "You are a marketplace moderator." | translate }}
            </div>

            <ng-container
              *ngIf="
                (listingUser.id === currentUserWrapper.user?.id ||
                  (currentUserWrapper.user | isMarketplaceModerator)) &&
                deviceService.mdMin()
              "
            >
              <ng-container
                [ngTemplateOutlet]="sidebarOwnerTemplate"
                [ngTemplateOutletContext]="{ currentUserWrapper }"
              ></ng-container>
            </ng-container>

            <ng-container *ngIf="listingUser.id !== currentUserWrapper.user?.id && deviceService.mdMin()">
              <ng-container
                [ngTemplateOutlet]="sidebarNonOwnerTemplate"
                [ngTemplateOutletContext]="{ currentUserWrapper, listingContentType }"
              ></ng-container>
            </ng-container>
          </div>
          <!-- col -->
        </div>
        <!-- row -->
      </ng-container>
      <!-- listingUser -->
    </ng-container>
    <!-- listingContentType -->
  </ng-container>
  <!-- currentUserWrapper -->

  <astrobin-scroll-to-top></astrobin-scroll-to-top>
</div>
<!-- page -->

<ng-template #loadingTemplate>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>

<ng-template #offers>
  <div id="offers" class="mt-4">
    <astrobin-marketplace-offer-summary
      [listing]="listing"
      (startPrivateConversation)="startPrivateConversation($event)"
    ></astrobin-marketplace-offer-summary>
  </div>
  <!-- offers -->
</ng-template>

<!-- Note: We no longer use this template directly as the content is now embedded in the accordion -->
<ng-template #privateConversationsTemplate></ng-template>

<ng-template #sidebarOwnerTemplate let-currentUserWrapper="currentUserWrapper">
  <div class="owner-buttons no-text text-center mt-0 mt-md-4">
    <a
      *ngIf="!equipmentMarketplaceService.listingSold(listing) && !equipmentMarketplaceService.listingReserved(listing)"
      [routerLink]="'edit'"
      class="btn btn-secondary btn-edit d-block w-100"
    >
      <fa-icon icon="pencil"></fa-icon>
      <span class="btn-text">{{ "Edit" | translate }}</span>
    </a>

    <button
      *ngIf="
        !equipmentMarketplaceService.listingSold(listing) && listing.listingType === MarketplaceListingType.FOR_SALE
      "
      (click)="markAsSold()"
      class="btn btn-secondary btn-mark-as-sold d-block w-100 mt-2"
    >
      <fa-icon icon="sack-dollar"></fa-icon>
      <span class="btn-text">{{ "Mark as sold" | translate }}</span>
    </button>

    <button
      *ngIf="!equipmentMarketplaceService.listingSold(listing) && !equipmentMarketplaceService.listingReserved(listing)"
      (click)="delete()"
      class="btn btn-danger btn-delete d-block w-100 mt-2"
    >
      <fa-icon icon="trash"></fa-icon>
      <span class="btn-text">{{ "Delete" | translate }}</span>
    </button>

    <button
      *ngIf="!equipmentMarketplaceService.listingSold(listing) && equipmentMarketplaceService.listingExpired(listing)"
      (click)="renew()"
      class="btn btn-secondary btn-renew d-block w-100 mt-2"
    >
      <fa-icon icon="redo"></fa-icon>
      <span class="btn-text">{{ "Renew" | translate }}</span>
    </button>
  </div>

  <ng-container [ngTemplateOutlet]="offers"></ng-container>

  <ng-container *ngIf="privateConversations$ | async as privateConversations">
    <div *ngIf="privateConversations?.length > 0" class="private-conversations card mt-4">
      <div class="card-header">
        {{ "Private conversations" | translate }}
      </div>
      <div class="card-body pt-4">
        <div class="d-flex flex-wrap justify-content-around">
          <div
            *ngFor="let privateConversation of privateConversations"
            class="avatar-wrapper text-center d-flex flex-column align-items-center"
          >
            <astrobin-avatar
              [link]="false"
              [userId]="privateConversation.user"
              (click)="startPrivateConversation(privateConversation, $event)"
            ></astrobin-avatar>

            <astrobin-username
              [link]="false"
              [userId]="privateConversation.user"
              (click)="startPrivateConversation(privateConversation, $event)"
              class="mt-2 d-inline-block"
            ></astrobin-username>

            <span *ngIf="equipmentMarketplaceService.userIsBuyer(privateConversation.user, listing)" class="buyer">
              ({{ "Buyer" | translate }})
            </span>

            <span *ngIf="privateConversation.unreadMessages > 0" class="badge bg-danger">
              {{ privateConversation.unreadMessages }}
            </span>

            <span *ngIf="privateConversation.unreadMessages === 0" class="badge bg-info">
              {{ privateConversation.totalMessages }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template
  #sidebarNonOwnerTemplate
  let-currentUserWrapper="currentUserWrapper"
  let-listingContentType="listingContentType"
>
  <ng-container [ngTemplateOutlet]="offers"></ng-container>

  <div class="non-owner-buttons no-text text-center">
    <ng-container *ngIf="!equipmentMarketplaceService.listingSold(listing)">
      <astrobin-toggle-property
        *ngIf="!equipmentMarketplaceService.listingHasOffers(listing)"
        [contentType]="listingContentType.id"
        [objectId]="listing.id"
        [userId]="currentUserWrapper.user?.id"
        class="btn-follow p-0 mt-md-4 w-100"
        btnClass="btn btn-secondary w-100"
        propertyType="follow"
      ></astrobin-toggle-property>
    </ng-container>

    <button
      *ngIf="listing.approved"
      [class.btn-primary]="
        currentUserWrapper.user &&
        equipmentMarketplaceService.listingReservedTo(listing, currentUserWrapper.user?.id) &&
        !equipmentMarketplaceService.listingSold(listing)
      "
      [class.btn-secondary]="
        !currentUserWrapper.user ||
        !equipmentMarketplaceService.listingReservedTo(listing, currentUserWrapper.user?.id) ||
        equipmentMarketplaceService.listingSold(listing)
      "
      [class.loading]="loadingService.loading$ | async"
      (click)="onMessageUserClicked($event)"
      class="btn btn-message mt-md-2 w-100"
    >
      <fa-icon icon="envelope"></fa-icon>

      <ng-container
        *ngIf="
          currentUserWrapper.user &&
            equipmentMarketplaceService.listingReservedTo(listing, currentUserWrapper.user?.id) &&
            !equipmentMarketplaceService.listingSold(listing);
          else messageUser
        "
      >
        <span class="btn-text">{{ "Exchange payment/delivery info" | translate }}</span>
      </ng-container>

      <ng-template #messageUser>
        <span class="btn-text">{{ "Message user privately" | translate }}</span>
      </ng-template>

      <ng-container *ngIf="privateConversations$ | async as privateConversations">
        <ng-container
          *ngIf="
            privateConversations?.length === 1 &&
            !equipmentMarketplaceService.listingReserved(listing) &&
            !equipmentMarketplaceService.listingSold(listing)
          "
        >
          <span *ngIf="privateConversations[0].unreadMessages > 0" class="badge bg-danger">
            {{ privateConversations[0].unreadMessages }}
          </span>
          <span *ngIf="privateConversations[0].unreadMessages === 0" class="badge bg-info">
            {{ privateConversations[0].totalMessages }}
          </span>
        </ng-container>
      </ng-container>
    </button>

    <button
      *ngIf="
        listing.listingType === MarketplaceListingType.FOR_SALE &&
        equipmentMarketplaceService.listingHasNonSoldNonReservedItems(listing) &&
        !equipmentMarketplaceService.listingHasPendingOffers(listing) &&
        !equipmentMarketplaceService.listingHasAcceptedOffers(listing) &&
        listing.approved
      "
      [class.loading]="loadingService.loading$ | async"
      (click)="onMakeAnOfferClicked($event)"
      class="btn btn-primary btn-make-offer mt-md-2 w-100"
    >
      <fa-icon icon="dollar"></fa-icon>
      <span class="btn-text">{{ "Make an offer" | translate }}</span>
    </button>

    <button
      *ngIf="listing.approved"
      [class.loading]="loadingService.loading$ | async"
      (click)="onReportListingClicked($event)"
      class="btn btn-link btn-report link-secondary mt-md-3 px-4 px-lg-2"
    >
      <fa-icon icon="flag"></fa-icon>
      <span class="btn-text">{{ "Report listing" | translate }}</span>
    </button>
  </div>
</ng-template>

<ng-template #ownerButtonsTemplate let-currentUserWrapper="currentUserWrapper">
  <div>
    <!-- Using NgbAccordion instead of Bootstrap accordion -->
    <ngb-accordion #ownerAccordion [closeOthers]="true" activeIds="panel-management">
      <!-- Management Section -->
      <ngb-panel id="panel-management" title="{{ 'Management' | translate }}">
        <ng-template ngbPanelContent>
          <div class="p-0">
            <ul class="nav offcanvas-menu flex-column">
              <li
                *ngIf="
                  !equipmentMarketplaceService.listingSold(listing) &&
                  !equipmentMarketplaceService.listingReserved(listing)
                "
                class="nav-item"
              >
                <a [routerLink]="'edit'" class="nav-link menu-item btn-sm">
                  <fa-icon icon="pencil"></fa-icon>
                  <span class="menu-text">{{ "Edit" | translate }}</span>
                </a>
              </li>

              <li
                *ngIf="
                  !equipmentMarketplaceService.listingSold(listing) &&
                  listing.listingType === MarketplaceListingType.FOR_SALE
                "
                class="nav-item"
              >
                <a (click)="markAsSold()" class="nav-link menu-item btn-sm">
                  <fa-icon icon="sack-dollar"></fa-icon>
                  <span class="menu-text">{{ "Mark as sold" | translate }}</span>
                </a>
              </li>

              <li
                *ngIf="
                  !equipmentMarketplaceService.listingSold(listing) &&
                  equipmentMarketplaceService.listingExpired(listing)
                "
                class="nav-item"
              >
                <a (click)="renew()" class="nav-link menu-item btn-sm">
                  <fa-icon icon="redo"></fa-icon>
                  <span class="menu-text">{{ "Renew" | translate }}</span>
                </a>
              </li>

              <li
                *ngIf="
                  !equipmentMarketplaceService.listingSold(listing) &&
                  !equipmentMarketplaceService.listingReserved(listing)
                "
                class="nav-item"
              >
                <a (click)="delete()" class="nav-link menu-item text-danger btn-sm">
                  <fa-icon icon="trash"></fa-icon>
                  <span class="menu-text">{{ "Delete" | translate }}</span>
                </a>
              </li>

              <!-- Message about sold items -->
              <li *ngIf="equipmentMarketplaceService.listingSold(listing)" class="nav-item">
                <div class="alert alert-info m-0 p-0 small">
                  <fa-icon class="me-1" icon="info-circle"></fa-icon>
                  {{ "Sold listings cannot be modified or deleted." | translate }}
                </div>
              </li>

              <!-- Message about reserved items -->
              <li
                *ngIf="
                  !equipmentMarketplaceService.listingSold(listing) &&
                  equipmentMarketplaceService.listingReserved(listing)
                "
                class="nav-item"
              >
                <div class="alert alert-info m-0 p-0 small">
                  <fa-icon class="me-1" icon="info-circle"></fa-icon>
                  {{ "Reserved listings cannot be modified or deleted." | translate }}
                </div>
              </li>
            </ul>
          </div>
        </ng-template>
      </ngb-panel>

      <!-- Offers Section -->
      <ngb-panel
        *ngIf="equipmentMarketplaceService.listingHasOffers(listing)"
        id="panel-offers"
        title="{{ 'Offers' | translate }} ({{ equipmentMarketplaceService.getTotalOfferCount(listing) }})"
      >
        <ng-template ngbPanelContent>
          <div class="p-0">
            <ng-container [ngTemplateOutlet]="offers"></ng-container>
          </div>
        </ng-template>
      </ngb-panel>

      <!-- Private Conversations Section -->
      <ngb-panel
        *ngIf="(privateConversations$ | async)?.length > 0"
        id="panel-conversations"
        title="{{ 'Private conversations' | translate }} ({{ (privateConversations$ | async)?.length || 0 }})"
      >
        <ng-template ngbPanelContent>
          <div class="p-0">
            <ul class="nav offcanvas-menu flex-column">
              <ng-container *ngIf="privateConversations$ | async as privateConversations">
                <li *ngFor="let privateConversation of privateConversations" class="nav-item">
                  <a
                    (click)="startPrivateConversation(privateConversation, $event)"
                    class="nav-link d-flex align-items-center btn-sm"
                  >
                    <astrobin-avatar
                      [link]="false"
                      [userId]="privateConversation.user"
                      class="me-2"
                      style="width: 40px"
                    ></astrobin-avatar>

                    <div class="d-flex flex-column align-items-start">
                      <span class="d-flex align-items-center">
                        <astrobin-username [link]="false" [userId]="privateConversation.user"></astrobin-username>
                        <span
                          *ngIf="equipmentMarketplaceService.userIsBuyer(privateConversation.user, listing)"
                          class="ms-1 buyer"
                        >
                          ({{ "Buyer" | translate }})
                        </span>
                      </span>

                      <span class="d-flex mt-1">
                        <span *ngIf="privateConversation.unreadMessages > 0" class="badge bg-danger">
                          {{ privateConversation.unreadMessages }}
                        </span>
                        <span *ngIf="privateConversation.unreadMessages === 0" class="badge bg-info">
                          {{ privateConversation.totalMessages }}
                        </span>
                      </span>
                    </div>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</ng-template>

<ng-template
  #nonOwnerButtonsTemplate
  let-currentUserWrapper="currentUserWrapper"
  let-listingContentType="listingContentType"
>
  <div>
    <!-- Using NgbAccordion instead of Bootstrap accordion -->
    <ngb-accordion #buyerAccordion [closeOthers]="true" activeIds="panel-buyer-actions">
      <!-- Actions Section -->
      <ngb-panel id="panel-buyer-actions" title="{{ 'Actions' | translate }}">
        <ng-template ngbPanelContent>
          <div class="p-0">
            <ul class="nav offcanvas-menu flex-column">
              <li
                *ngIf="
                  !equipmentMarketplaceService.listingSold(listing) &&
                  !equipmentMarketplaceService.listingHasOffers(listing)
                "
                class="nav-item"
              >
                <astrobin-toggle-property
                  [contentType]="listingContentType.id"
                  [objectId]="listing.id"
                  [userId]="currentUserWrapper.user?.id"
                  class="p-0"
                  btnClass="nav-link menu-item btn btn-link btn-no-block link-secondary btn-sm"
                  propertyType="follow"
                ></astrobin-toggle-property>
              </li>

              <li *ngIf="listing.approved" class="nav-item">
                <a
                  [class.loading]="loadingService.loading$ | async"
                  (click)="onMessageUserClicked($event)"
                  class="nav-link menu-item btn-sm"
                >
                  <fa-icon icon="envelope"></fa-icon>

                  <ng-container
                    *ngIf="
                      currentUserWrapper.user &&
                        equipmentMarketplaceService.listingReservedTo(listing, currentUserWrapper.user?.id) &&
                        !equipmentMarketplaceService.listingSold(listing);
                      else messageUserMobile
                    "
                  >
                    <span class="menu-text">{{ "Exchange payment/delivery info" | translate }}</span>
                  </ng-container>

                  <ng-template #messageUserMobile>
                    <span class="menu-text">{{ "Message user privately" | translate }}</span>
                  </ng-template>

                  <ng-container *ngIf="privateConversations$ | async as privateConversations">
                    <ng-container
                      *ngIf="
                        privateConversations?.length === 1 &&
                        !equipmentMarketplaceService.listingReserved(listing) &&
                        !equipmentMarketplaceService.listingSold(listing)
                      "
                    >
                      <span *ngIf="privateConversations[0].unreadMessages > 0" class="badge bg-danger">
                        {{ privateConversations[0].unreadMessages }}
                      </span>
                      <span *ngIf="privateConversations[0].unreadMessages === 0" class="badge bg-info">
                        {{ privateConversations[0].totalMessages }}
                      </span>
                    </ng-container>
                  </ng-container>
                </a>
              </li>

              <li
                *ngIf="
                  listing.listingType === MarketplaceListingType.FOR_SALE &&
                  equipmentMarketplaceService.listingHasNonSoldNonReservedItems(listing) &&
                  !equipmentMarketplaceService.listingHasPendingOffers(listing) &&
                  !equipmentMarketplaceService.listingHasAcceptedOffers(listing) &&
                  listing.approved
                "
                class="nav-item"
              >
                <a
                  [class.loading]="loadingService.loading$ | async"
                  (click)="onMakeAnOfferClicked($event)"
                  class="nav-link menu-item btn-sm"
                >
                  <fa-icon icon="dollar"></fa-icon>
                  <span class="menu-text">{{ "Make an offer" | translate }}</span>
                </a>
              </li>

              <li *ngIf="listing.approved" class="nav-item">
                <a
                  [class.loading]="loadingService.loading$ | async"
                  (click)="onReportListingClicked($event)"
                  class="nav-link menu-item btn-sm"
                  style="color: var(--lightGrey)"
                >
                  <fa-icon icon="flag"></fa-icon>
                  <span class="menu-text">{{ "Report listing" | translate }}</span>
                </a>
              </li>
            </ul>
          </div>
        </ng-template>
      </ngb-panel>

      <!-- Your Offers Section -->
      <ngb-panel
        *ngIf="equipmentMarketplaceService.listingHasOffers(listing)"
        id="panel-my-offers"
        title="{{ 'My Offers' | translate }} ({{
          equipmentMarketplaceService.getUserOfferCount(listing, currentUserWrapper.user)
        }})"
      >
        <ng-template ngbPanelContent>
          <div class="p-0">
            <ng-container [ngTemplateOutlet]="offers"></ng-container>
          </div>
        </ng-template>
      </ngb-panel>

      <!-- Private Conversations Section -->
      <ngb-panel
        *ngIf="(privateConversations$ | async)?.length > 0"
        id="panel-buyer-conversations"
        title="{{ 'Private conversations' | translate }} ({{ (privateConversations$ | async)?.length || 0 }})"
      >
        <ng-template ngbPanelContent>
          <div class="p-0">
            <ul class="nav offcanvas-menu flex-column">
              <ng-container *ngIf="privateConversations$ | async as privateConversations">
                <li *ngFor="let privateConversation of privateConversations" class="nav-item">
                  <a
                    (click)="startPrivateConversation(privateConversation, $event)"
                    class="nav-link d-flex align-items-center btn-sm"
                  >
                    <astrobin-avatar
                      [link]="false"
                      [userId]="listing.user"
                      class="me-2"
                      style="width: 40px"
                    ></astrobin-avatar>

                    <div class="d-flex flex-column align-items-start">
                      <span class="d-flex align-items-center">
                        <span class="menu-text">{{ listing.userDisplayName }}</span>
                      </span>

                      <span class="d-flex mt-1">
                        <span *ngIf="privateConversation.unreadMessages > 0" class="badge bg-danger">
                          {{ privateConversation.unreadMessages }}
                        </span>
                        <span *ngIf="privateConversation.unreadMessages === 0" class="badge bg-info">
                          {{ privateConversation.totalMessages }}
                        </span>
                      </span>
                    </div>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</ng-template>

<ng-template #titleTemplate>
  {{ title }}
</ng-template>

<ng-template #descriptionTemplate>
  <span class="d-block listing-info">
    <span class="listing-info-section">
      <fa-icon icon="calendar"></fa-icon>
      <ng-container *ngIf="listing.approved">
        {{ "Published" | translate }}: {{ listing.approved | localDate | timeago: true }}
      </ng-container>

      <ng-container *ngIf="!listing.approved">
        {{ "Created" | translate }}: {{ listing.created | localDate | timeago: true }}
      </ng-container>
    </span>

    <span class="listing-info-section-separator">&middot;</span>

    <span class="listing-info-section">
      <fa-icon icon="bell"></fa-icon>
      <span *ngIf="listing.followerCount === 0" [translate]="'No followers yet'"></span>
      <span *ngIf="listing.followerCount === 1" [translate]="'One follower'"></span>
      <span
        *ngIf="listing.followerCount > 1"
        [translate]="'{{0}} followers'"
        [translateParams]="{
          '0': listing.followerCount
        }"
      ></span>
    </span>

    <span class="listing-info-section-separator">&middot;</span>

    <span class="listing-info-section">
      <fa-icon icon="eye"></fa-icon>
      <span *ngIf="listing.viewCount === 0" [translate]="'No views yet'"></span>
      <span *ngIf="listing.viewCount === 1" [translate]="'One view'"></span>
      <span
        *ngIf="listing.viewCount > 1"
        [translate]="'{{0}} views'"
        [translateParams]="{
          '0': listing.viewCount
        }"
      ></span>
    </span>

    <span class="listing-info-section-separator">&middot;</span>

    <span class="listing-info-section">
      <fa-icon icon="clock"></fa-icon>
      {{ "Expiration" }}: {{ listing.expiration | localDate | timeago: true }}
    </span>
  </span>
</ng-template>

<ng-template #shareButtonsTemplate>
  <button (click)="share($event)" class="btn btn-link btn-no-block btn-sm">
    <fa-icon [icon]="deviceService.getShareIcon()"></fa-icon>
  </button>
</ng-template>
